module.exports = __webpack_public_path__ + "static/media/moone-tb.21e9b87d.png";